import axios from "axios";
import {
  AccessRequestPayload,
  UpdateAccessPayload,
} from "../../types/auth.types";

export const getToken = (hasToken: "0" | "1", email: string): Promise<any> => {
  return axios.get(`/api/login?hasToken=${hasToken}&email=${email}`);
};

export const getUsers = (): Promise<any> => axios.get("/api/users");

export const sendUserRequest = (data: AccessRequestPayload): Promise<any> => {
  return axios.get(`/api/access-request?data=${JSON.stringify(data)}`);
};

export const updateUserAccess = (data: UpdateAccessPayload): Promise<any> => {
  return axios.get(`/api/update-access?data=${JSON.stringify(data)}`);
};

export const deleteUserAccess = (id: string): Promise<any> => {
  return axios.get(`/api/delete-access?id=${id}`);
};
